export default [
  {
    path: '/cry',
    component: () => import('@/views/cry/CryMain.vue'),
    meta: {
      isHeader: false,
      isBack: false,
      isNav: true,
      titleName: ''
    }
  },
  {
    path: '/cry/search',
    component: () => import('@/views/cry/search/CrySearch.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: 'Cry Together 검색'
    }
  },
  {
    path: '/cry/memorial/menu',
    component: () => import('@/views/cry/memorial/MemorialMenu.vue'),
    meta: {
      isHeader: false,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: '추모관 선택'
    }
  },
  {
    path: '/cry/memorial/search',
    component: () => import('@/views/cry/memorial/MemorialSearch.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: ''
    }
  },
  {
    path: '/cry/funeral/search',
    component: () => import('@/views/cry/funeral/FuneralSearch.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '온라인 장례식장 검색'
    }
  },

  {
    path: '/cry/preview',
    component: () => import('@/views/memorial/register/CryGalleryPreView.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '미리보기'
    }
  }
];
